import ThemeConfig from "./ThemeConfig";

export { ThemeConfig };
